export default "__VITE_ASSET__DuS1vVzK__"